<template>
  <div>
    <h3 class="info-title">认证设置</h3>
    <el-divider />
    <el-form ref="form" :model="form" :rules="rules" :label-position="labelPosition" label-width="110px">
      <el-form-item prop="accountName" label="TP-LINK ID"> {{ accountName }} </el-form-item>
      <el-form-item prop="enterpriseName" label="企业名称">
        <el-input v-model="form.enterpriseName" clearable placeholder="请输入企业名称" />
      </el-form-item>
      <el-form-item prop="licenseType" label="企业证件"> 工商营业执照 </el-form-item>
      <el-form-item prop="licenseId" label="企业证件号码">
        <el-input v-model="form.licenseId" clearable placeholder="请输入企业证件号码" />
      </el-form-item>
      <el-form-item prop="personName" label="法人代表">
        <el-input v-model="form.personName" clearable placeholder="请输入法人代表姓名" />
      </el-form-item>
      <el-form-item prop="cardType" label="法人证件类型"> 中华人民共和国居民身份证 </el-form-item>
      <el-form-item prop="cardId" label="法人证件号码">
        <el-input v-model="form.cardId" clearable placeholder="请输入证件号码" />
      </el-form-item>
      <el-form-item prop="contactPerson" label="企业联系人">
        <el-input v-model="form.contactPerson" clearable placeholder="请输入企业联系人姓名" />
      </el-form-item>
      <el-form-item prop="contact" label="联系方式">
        <el-input v-model="form.contact" clearable placeholder="请输入企业联系人手机号码或邮箱" />
      </el-form-item>
    </el-form>

    <h3 class="info-title"> 上传证件 <el-link type="info"> 支持 jpg 或 png 格式，照片大小限 2M 以内 </el-link> </h3>
    <el-divider />
    <el-row style="margin-bottom: 1%">
      <el-col :sm="8" :xs="24">
        <p> <span style="color:red;"> * </span> 组织机构代码证或营业执照 </p>
        <p style="color: #909399"> 请使用原件或加盖公章的复印件拍照 </p>
      </el-col>
      <el-col :sm="16" :xs="24">
        <el-upload
            class="avatar-uploader"
            style="width: 300px; height: 160px; border: 1px dashed darkgray;"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            accept=".png,.jpg,.jpeg"
            :on-change="getLicenseBase64"
        >
          <img v-if="imageUrl1" :src="imageUrl1" class="avatar" alt="">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 1%">
      <el-col :sm="8" :xs="24">
        <p> <span style="color:red;"> * </span> 法人身份证原件人像面 </p>
      </el-col>
      <el-col :sm="16" :xs="24">
        <el-upload
            class="avatar-uploader"
            style="width: 300px; height: 160px; border: 1px dashed darkgray;"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            accept=".png,.jpg,.jpeg"
            :on-change="getCardHeadBase64"
        >
          <img v-if="imageUrl2" :src="imageUrl2" class="avatar" alt="">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 1%">
      <el-col :sm="8" :xs="24">
        <p> <span style="color:red;"> * </span> 法人身份证原件国徽面 </p>
      </el-col>
      <el-col :sm="16" :xs="24">
        <el-upload
            class="avatar-uploader"
            style="width: 300px; height: 160px; border: 1px dashed darkgray;"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            accept=".png,.jpg,.jpeg"
            :on-change="getCardTailBase64"
        >
          <img v-if="imageUrl3" :src="imageUrl3" class="avatar" alt="">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-col>
    </el-row>
    <div class="protocol">
      <el-checkbox v-model="checked" /> 我已阅读并接受<el-button type="text" @click="checkProtocol.service=true">《用户服务协议》</el-button>和<el-button type="text" @click="checkProtocol.privacy=true">《隐私政策》</el-button>
    </div>
    <service v-if="checkProtocol.service === true" @refuse="handleRefuse" @agree="handleAgree"/>
    <privacy v-if="checkProtocol.privacy === true" @refuse="handleRefuse" @agree="handleAgree" />
    <div class="butt">
      <el-popconfirm
          confirm-button-text='确认'
          cancel-button-text='取消'
          icon="el-icon-info"
          icon-color="red"
          title="企业实名认证完成后将无法进行个人实名认证，是否确认？"
          @confirm="handleSubmit"
      >
        <el-button slot="reference" :loading="loading" type="primary" :disabled="!checked">
          <span v-if="!loading"> 同意协议并提交 </span>
          <span v-else> 提 交 中... </span>
        </el-button>
      </el-popconfirm>
    </div>
  </div>
</template>

<script>
import Config from "@/config"
import Service from "../../components/agreement.vue"
import Privacy from "../../components/privacy.vue"
import { filetoBase64Img, validateLicense, validateCard, validateContact, notify } from "@/utils/util";

export default {
  name: "Enterprise",
  components: { Service, Privacy },
  props: {
    accountName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      labelPosition: "left",
      form: {
        accountName: "",
        enterpriseName: "",
        licenseType: 0,
        licenseId: "",
        personName: "",
        cardType: 0,
        cardId: "",
        contactPerson: "",
        contact: "",
        licenseBase64: "",
        cardHeadBase64: "",
        cardTailBase64: "",
        userType: 1,
      },
      rules: {
        accountName: [{required: true, message: "请输入TP-LINK ID", trigger: "blur"}],
        enterpriseName: [{required: true, message: "请输入企业名称", trigger: "blur"}],
        licenseType: [{required: true, message: "请输入正确的企业证件类型", trigger: "blur"}],
        licenseId: [{required: true, message: "请输入正确的企业证件号码", trigger: "blur"}, {validator: validateLicense, trigger: "blur"}],
        personName: [{required: true, message: "请输入法人代表姓名", trigger: "blur"}],
        cardType: [{required: true, message: "请输入法人证件类型", trigger: "blur"}],
        cardId: [{required: true, message: "请输入正确的证件号码", trigger: "blur"}, {validator: validateCard, trigger: "blur"}],
        contactPerson: [{required: true, message: "请输入企业联系人姓名", trigger: "blur"}],
        contact: [{required: true, message: "请输入企业联系人手机/电子邮箱", trigger: "blur"}, {validator: validateContact, trigger: "blur"}]
      },
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      checked: false,
      loading: false,
      checkProtocol: {service: false, privacy: false}
    }
  },
  watch: {
    accountName: function () {
      console.log('accountName', this.accountName)
      this.form.accountName = this.accountName
    }
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    handleSubmit () {
      this.loading = true
      this.form.accountName = this.accountName
      if (!this.imageUrl1 || !this.imageUrl2 || !this.imageUrl3) {
        this.loading = false
        notify(Config.notifyErr, Config.submitErr)
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          const submitData = {
            accountName: this.form.accountName,
            userType: 1,
            enterpriseName: this.form.enterpriseName,
            cardHeadBase64: this.form.cardHeadBase64,
            cardTailBase64: this.form.cardTailBase64,
            licenseBase64: this.form.licenseBase64,
            licenseId: this.form.licenseId,
            licenseType: 0,
            cardId: this.form.cardId,
            personName: this.form.personName,
            cardType: 0,
            contact: this.form.contact,
            contactPerson: this.form.contactPerson,
          }
          this.$emit('onSubmit', submitData, response => {
            this.loading = false
            if (response) {
              this.resetForm()
            } else {
              console.log("Submit error!")
            }
          })
        } else {
          this.loading = false
          notify(Config.notifyErr, Config.submitErr)
        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isJPEG && !isPNG) {
        notify(Config.notifyErr, Config.picTypeErr)
        return false
      }
      if (!isLt2M) {
        notify(Config.notifyErr, Config.picOutSize)
        return false
      }
      return true
    },
    getLicenseBase64 (file) {
      if (!this.beforeAvatarUpload(file.raw)) return false
      this.imageUrl1 = URL.createObjectURL(file.raw)
      filetoBase64Img(file.raw).then(response => {
        this.form.licenseBase64 = response
      }).catch(error => {
        console.log(error)
      })
    },
    getCardHeadBase64 (file) {
      if (!this.beforeAvatarUpload(file.raw)) return false
      this.imageUrl2 = URL.createObjectURL(file.raw)
      filetoBase64Img(file.raw).then(response => {
        this.form.cardHeadBase64 = response
      }).catch(error => {
        console.log(error)
      })
    },
    getCardTailBase64 (file) {
      if (!this.beforeAvatarUpload(file.raw)) return false
      this.imageUrl3 = URL.createObjectURL(file.raw)
      filetoBase64Img(file.raw).then(response => {
        this.form.cardTailBase64 = response
      }).catch(error => {
        console.log(error)
      })
    },

    handleAgree ({key}) {
      console.log(key)
      this.checkProtocol[key] = false
      this.checked = true
    },
    handleRefuse ({key}) {
      this.checkProtocol[key] = false
      this.checked = false
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}

.info-title {
  margin-top: 5%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: blue;
  width: 300px;
  height: 160px;
  line-height: 160px;
  text-align: center;
}

.avatar {
  width: 300px;
  height: 160px;
  display: block;
}

.butt {
  margin-top: 20px;
}

p {
  font-size: 14px;
}

.protocol {
  font-size: 14px;
}
</style>